import { AlertTriangle } from 'lucide-react'
import { Modal } from './Modal'

export function ConfirmModal({ open, title, message, confirmLabel = 'Удалить', danger = true, onConfirm, onClose }: { open: boolean; title: string; message: string; confirmLabel?: string; danger?: boolean; onConfirm: () => void; onClose: () => void }) {
  return <Modal open={open} title={title} onClose={onClose}>
    <div className="confirm-copy"><span className="confirm-icon"><AlertTriangle/></span><p>{message}</p></div>
    <footer className="modal-actions"><button className="button ghost" onClick={onClose}>Отмена</button><button className={`button ${danger ? 'danger' : 'primary'}`} onClick={onConfirm}>{confirmLabel}</button></footer>
  </Modal>
}
